module.exports = __webpack_public_path__ + "img/figure-8.3c2f1add.png";